// extracted by mini-css-extract-plugin
module.exports = {"BlueFont":"header-module--BlueFont--FdvQ7"};